import React from 'react';
import { usePermissions } from '../../hooks/usePermissions';
import { Permission, Resource } from '../../constants/permissions';

interface PermissionGateProps {
  resource: Resource;
  permission: Permission;
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export const PermissionGate: React.FC<PermissionGateProps> = ({
  resource,
  permission,
  children,
  fallback = null,
}) => {
  const { can } = usePermissions();

  if (can(resource, permission)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};

interface MultiPermissionGateProps {
  resource: Resource;
  permissions: Permission[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
  requireAll?: boolean;
}

export const MultiPermissionGate: React.FC<MultiPermissionGateProps> = ({
  resource,
  permissions,
  children,
  fallback = null,
  requireAll = false,
}) => {
  const { hasAllPermissions, hasAnyPermission } = usePermissions();

  const hasPermission = requireAll 
    ? hasAllPermissions(resource, permissions)
    : hasAnyPermission(resource, permissions);

  if (hasPermission) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
}; 